import { isArguments } from "lodash-es";

export const usePlatform = () => {
  const browser = {
    versions: function() {
      const u = navigator.userAgent;
      return { //移动终端浏览器版本信息
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
        isChrome: /Chrome/.test(u) && window.chrome,  // 是否是谷歌浏览器
      };
    }()
  }

  // 检测是否在受限的社交软件内嵌浏览器中（国际用户常用）
  const isChromeCallableEnv = () => {
    const ua = navigator.userAgent.toLowerCase();
    // 1. 检测常见的国际社交软件内嵌浏览器标识（这些环境中唤起受限）
    const restrictedSocialPatterns = [
        /fbav/i,           // Facebook
        /twitter/i,        // Twitter
        /instagram/i,      // Instagram
        /discord/i,        // Discord
        /snapchat/i        // Snapchat
    ];
    // 2. 可能调用系统默认浏览器的社交软件（如WhatsApp、Telegram等）
    const callableSocialPatterns = [
        /whatsapp/i,       // WhatsApp - 通常调用系统浏览器
        /telegram/i        // Telegram - 通常调用系统浏览器
    ];
    return callableSocialPatterns.some(pattern => pattern.test(ua)) || !restrictedSocialPatterns.some(pattern => pattern.test(ua));
  }

  let platform = '';
  if (browser.versions.mobile) { //判断是否是移动设备打开.
    var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    if (window.$bridge) {//app内打开
      platform = 'app'
    } else if (ua.match(/MicroMessenger/i) == "micromessenger") { //在微信中打开
      platform = 'wechat'
    } else if (browser.versions.ios) { //IOS浏览器打开
      platform = 'ios'
    } else { // (browser.versions.android)安卓浏览器打开
      platform = 'android'
    }
  } else { //否则就是PC浏览器打开
    platform = 'pc'
  }

  return { 
    platform,
    isApp: platform === 'app',
    isWechat: platform === 'wechat',
    isIOS: platform === 'ios',
    isAndroid: platform === 'android',
    isPC: platform === 'pc',
    isChrome: browser.versions.isChrome,
    isStandalone: window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone,
    canCallChrome: isChromeCallableEnv(),
  };
} 
  